import React from 'react'
import styled from 'styled-components'
import { useConfigState } from '@sentecacommerce-theme/lib'
import { Placeholder } from '../Placeholder'

import { IconBasket } from '../Icons'

export const LineItemPlaceholder = () => {
  const config = useConfigState()
  return (
    <Container>
      <ImageContainer>
        <Image>
          <Placeholder absolute />
        </Image>
      </ImageContainer>
      <Content>
        <Placeholder className="mb-3" width="33%" />
        <Placeholder className="mb-3" width="65%" />
        <Placeholder width="60%" />
      </Content>
      <CTAWrapper>
        <PriceWrapper>
          <Placeholder width="4.5rem" />
        </PriceWrapper>
        <CartWrapper>
          <IconBasket width="32" height="32" fill={config.palette.silverTree} />
        </CartWrapper>
      </CTAWrapper>
    </Container>
  )
}

const Image = styled.div`
  width: 100%;
  height: 15rem;
  position: relative;
  overflow: hidden;
  border-radius: 4rem;
`

const CartWrapper = styled.div`
  @media only screen and (${({ theme }) => theme.breakpoints.sm.max}) {
    margin-right: 0.5rem;
  }
  cursor: pointer;
  &:hover {
    transform: scale(1.3);
  }
  transition: all 0.3s;
`

const CTAWrapper = styled.div.attrs({
  className: 'pt-0 px-4 pb-4',
})`
  position: relative;
  margin-top: auto;
  align-items: center;
  display: flex !important;

  @media only screen and (${({ theme }) => theme.breakpoints.sm.max}) {
    padding: 0 0 1.5rem 1.5rem;
  }
`

const Container = styled.div`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 1rem;
  border: 0.1rem solid transparent;
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.palette.secondary};
  min-height: 35.6rem;
  box-shadow: 0 0 0.8rem #e6e5e5;
  transition: box-shadow 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);

  transform: translateY(0);
  &:hover {
    box-shadow: 0 0.5rem 1.6rem rgba(0, 0, 0, 0.15);
    transform: translateY(-0.6rem);
  }
`

const PriceWrapper = styled.div`
  color: ${({ theme }) => theme.palette.primary};
  font-size: 1.8rem;
  margin-right: auto;

  @media only screen and (${({ theme }) => theme.breakpoints.sm.max}) {
    font-size: 1.4rem;
  }

  & > div {
    height: 1rem;
  }
`

const ImageContainer = styled.div`
  padding: 2rem 1.5rem;
`

const Content = styled.div.attrs({
  className: 'mb-4 py-0 px-4',
})`
  height: 7.5rem;
`
